import { defaultAxios, IParams } from './base';

export interface IFetchCustTotalProductSummary extends IParams {
  custSeq?: number;
}

export const fetchCustTotalProductSummary = (
  params: IFetchCustTotalProductSummary,
) => {
  return defaultAxios().post(`cust/v2/total/product/summary`, params);
};
